import React from "react";
import Usage from "../Components/Usage/Usage";

const UsagePage = () => {
  return <Usage />;
};

export default UsagePage;
